
import {Button} from '/ui/components/button/button';
import {CalloutBanner, CalloutBannerType} from '/ui/components/calloutbanner/calloutbanner';

export function ErrorCallout({onReload}) {
  const calloutMessage =
    <>
      {yext.msg('There was an error loading this section.')}&nbsp;
      <Button chromeless={true} onClick={onReload}>{yext.msg('Please click to reload.')}</Button>
    </>;

  return (
    <CalloutBanner
      type={CalloutBannerType.ERROR}
      title={undefined}
      children={calloutMessage}>
    </CalloutBanner>
  );
}
